import { ServiceRoute, GLServiceBase } from "../../src/commonui/services";
import { ResourceType } from "@/commonui/utils";
export type ResourcePropagation = {
	resourceType: ResourceType;
	resourceKey: string;
};

class InvitationTemplateServiceClass extends GLServiceBase<any, any> {
	serviceRoute: ServiceRoute = { prefix: "admin/v1/invitationTemplates", suffix: "{id}" };

	getTemplateCandidates(params: any) {
		return this.get("candidates", params);
	}
	previewInvitationTemplate(params: any) {
		return this.get("preview", params);
	}
}

export const InvitationTemplateService = new InvitationTemplateServiceClass();
